export const upButton = () => {
    return (
        <svg  
        xmlns="http://www.w3.org/2000/svg"  
        width="24"  
        height="24"  
        viewBox="0 0 22 22"  
        fill="none"  
        stroke="var(--accent)"  
        strokeWidth="1"  
        strokeLinecap="round"  
        strokeLinejoin="round"  
        className="icon icon-tabler icons-tabler-outline icon-tabler-circle-chevron-up">
            <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
            <path d="M9 13l3 -3l3 3" />
            <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
            </svg>
    );
};